// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"wj-z","carouselContainer":"xj-z","carouselContent":"yj-z"};